import React, { useEffect, useRef, useState } from 'react';
import RotatingComponents from '../components/RotatingComponents';
import AutoRefresh from '../components/AutoRefreshProps';
import DeltaHotelData from '../content/delta-hotel.json';
import moment from 'moment-timezone';

// Définir les écrans ici
function RateScreen() {
  return (
    <div
      className="flex min-h-screen flex-col justify-between"
      style={{ backgroundColor: '#121B4D' }}
    >
      <header
        className="relative border-b-2 p-[4vw]"
        style={{ backgroundColor: '#fff', borderColor: '#000' }}
      >
        <div className="items-right flex items-center justify-between">
          <img
            src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvZtPMhTcyRGx7hJ4azns8OUN12LWEqBpDXVw5"}
            alt="JPark Logo"
            className="max-h-[9.6vh] min-w-[30vw] max-w-[36vw] object-contain"
          />
          <div
            className="h-[4vh] min-h-[] w-[20px] rounded-lg"
            style={{ backgroundColor: '#8FBA02' }}
          ></div>
          <h2
            className="text-[6vw] font-extrabold"
            style={{ color: '#121B4D' }}
          >
            Hôtel Delta
          </h2>
        </div>
      </header>

      <div
        className="flex flex-grow flex-col justify-start px-[4vw] py-[2vh]"
        style={{ backgroundColor: '#121B4D', color: 'white' }}
      >
        <div className="mb-[4vh] flex justify-between">
          <div className="flex flex-col">
            <h2 className="mb-[1vh] text-[7vw] font-extrabold">
              {DeltaHotelData.dayFr.title}
            </h2>
            <p
              className="text text-[6vw] font-extrabold leading-none"
              style={{ color: '#8FBA02' }}
            >
              {DeltaHotelData.dayEn.title}
            </p>
          </div>
        </div>

        <div className="border-t-[8px]" style={{ borderColor: '#8FBA02' }}>
          <div
            className="flex justify-between border-b-[8px] py-[2vh]"
            style={{ borderColor: '#8FBA02' }}
          >
            <div className="flex max-w-[55%] flex-col justify-center">
              <p className="mb-[1vh] text-[4vw] font-bold leading-[1.2]">
                {DeltaHotelData.dayFr.line1Title}
              </p>
              <p
                className="text-[3.4vw] font-bold leading-[1.2]"
                style={{ color: '#8FBA02' }}
              >
                {DeltaHotelData.dayEn.line1Title}
              </p>
            </div>
            <div className="flex max-w-[45%] flex-col justify-center text-right">
              <p
                className="flex flex-col justify-center text-[5vw] font-extrabold"
                style={{ color: '#fff' }}
              >
                {DeltaHotelData.dayFr.line1Price}
              </p>
              <p
                className="flex flex-col justify-center text-[4vw] font-extrabold"
                style={{ color: '#fff' }}
              >
                {DeltaHotelData.dayFr.line1Desc}
              </p>
            </div>
          </div>

          <div
            className="flex justify-between border-b-[8px] py-[2vh]"
            style={{ borderColor: '#8FBA02' }}
          >
            <div className="flex max-w-[55%] flex-col justify-center">
              <p className="mb-[1vh] text-[4vw] font-bold leading-[1.2]">
                {DeltaHotelData.dayFr.line2Title}
              </p>
              <p
                className="text-[3.4vw] font-bold leading-[1.2]"
                style={{ color: '#8FBA02' }}
              >
                {DeltaHotelData.dayEn.line2Title}
              </p>
            </div>
            <div className="flex max-w-[40%] flex-col justify-center text-right">
              <p
                className="flex flex-col justify-center text-[5vw] font-extrabold"
                style={{ color: '#fff' }}
              >
                {DeltaHotelData.dayFr.line2Price}
              </p>
              <p
                className="flex flex-col justify-center text-[4vw] font-extrabold"
                style={{ color: '#fff' }}
              >
                {DeltaHotelData.dayFr.line2Desc}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-[6vh] flex flex-col items-center">
        <p
          className="flex flex-col justify-center text-[2.6vh] font-extrabold"
          style={{ color: '#fff' }}
        >
          {DeltaHotelData.ScreenTextFr.thankForVisit}
        </p>
        <p
          className="text-[2vh] font-bold leading-[1.2]"
          style={{ color: '#8FBA02' }}
        >
          {DeltaHotelData.ScreenTextEn.thankForVisit}
        </p>
      </div>

      <footer
        className="flex items-center justify-between px-[4vw] py-8"
        style={{ color: '#fff', backgroundColor: '#8FBA02' }}
      >
        <div className="flex flex-col justify-center">
          <p className="text-[6vw] font-extrabold" style={{ color: '#121B4D' }}>
            418 440-4638
          </p>
          <p className="text-[4vw] font-bold" style={{ color: '#121B4D' }}>
            www.parkeo.ca
          </p>
        </div>
        <img src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvISLsdMy90v6KjHCBGPeFM7ZVlwaISyA21ir8"} alt="Logo Parkeo" className="h-[6vh]" />
      </footer>
    </div>
  );
}

function TextScreen() {
  return (
    <div
      className="flex min-h-screen flex-col justify-between"
      style={{ backgroundColor: '#121B4D' }}
    >
      <header
        className="relative border-b-2 p-[4vw]"
        style={{ borderColor: '#000', backgroundColor: '#fff' }}
      >
        <div className="items-right flex items-center justify-between">
          <img
            src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvZtPMhTcyRGx7hJ4azns8OUN12LWEqBpDXVw5"}
            alt="JPark Logo"
            className="max-h-[9.6vh] min-w-[30vw] max-w-[36vw] object-contain"
          />
          <div
            className="h-[3vh] w-[20px] rounded-lg"
            style={{ backgroundColor: '#8FBA02' }}
          ></div>
          <h2
            className="text-[6vw] font-extrabold"
            style={{ color: '#121B4D' }}
          >
            Hôtel Delta
          </h2>
        </div>
      </header>

      <div
        className="flex flex-grow flex-col justify-start px-[4vw] py-[2vh]"
        style={{ backgroundColor: '#121B4D', color: '#fff' }}
      >
        <div className="mb-[4vh] flex justify-between">
          <h2 className="mb-[1vh] text-[7vw] font-extrabold">
            {DeltaHotelData.ScreenTextFr.important}
          </h2>
          <img src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvXkr9aDVUpbRaEqekQOl4mKjrfuBTCiWVcyJH"} alt="Logo Delta" className="h-[15vh]" />
        </div>

        <div className="mt-[-11vh] flex flex-1 flex-col justify-between">
          <div className="mb-[2vh] flex flex-col">
            <h2 className="mb-4 text-[5vw] font-extrabold">
              {DeltaHotelData.ScreenTextFr.hotelGuest}
            </h2>
            <h3
              className="text-[4vw] font-extrabold"
              style={{ color: '#8FBA02' }}
            >
              {DeltaHotelData.ScreenTextEn.hotelGuest}
            </h3>
          </div>

          <p className="text-[4vw] font-bold">
            {DeltaHotelData.ScreenTextFr.beforePaying} /{' '}
            <span className="text-[3.3vw]" style={{ color: '#8FBA02' }}>
              {DeltaHotelData.ScreenTextEn.beforePaying}
            </span>
          </p>

          <div className="flex flex-col">
            <p className="text-[4vw] font-bold">
              {DeltaHotelData.ScreenTextFr.if}
              <span className="underline">
                {DeltaHotelData.ScreenTextFr.include}
              </span>
              {DeltaHotelData.ScreenTextFr.pressOn}
              <span className="underline">
                {DeltaHotelData.ScreenTextFr.ticket}.
              </span>
            </p>
            <p className="text-[3.3vw] font-bold" style={{ color: '#8FBA02' }}>
              {DeltaHotelData.ScreenTextEn.ifInclude}
            </p>
          </div>

          <div className="flex flex-col">
            <p className="text-[4vw] font-bold">
              {DeltaHotelData.ScreenTextFr.ifNot}
            </p>
            <p className="text-[3.3vw] font-bold" style={{ color: '#8FBA02' }}>
              {DeltaHotelData.ScreenTextEn.ifNot}
            </p>
          </div>

          <div className="mb-5 mt-[3vh]">
            <img
              src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvNhL9hc05FK27ACG9JwPV1WhsETUj46HOgLNi"}
              alt="Logo Enterprise"
              className="h-[6vh] object-contain"
            />
          </div>

          <div className="flex flex-col">
            <p className="text-[4vw] font-bold">
              {DeltaHotelData.ScreenTextFr.enterprise}
            </p>
            <p className="text-[3.3vw] font-bold" style={{ color: '#8FBA02' }}>
              {DeltaHotelData.ScreenTextEn.enterprise}
            </p>
          </div>
        </div>
      </div>

      <footer
        className="flex items-center justify-between px-[4vw] py-8"
        style={{ color: '#fff', backgroundColor: '#8FBA02' }}
      >
        <div className="flex flex-col justify-center">
          <p
            className="text-[6vw] font-extrabold"
            style={{ color: '#121B4D', backgroundColor: '#8FBA02' }}
          >
            418 440-4638
          </p>
          <p className="text-[4vw] font-bold" style={{ color: '#121B4D' }}>
            www.parkeo.ca
          </p>
        </div>
        <img src={"https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvISLsdMy90v6KjHCBGPeFM7ZVlwaISyA21ir8"} alt="Logo Parkeo" className="h-[6vh]" />
      </footer>
    </div>
  );
}

function EventScreen() {
  return (
    <div
      style={{
        position: 'relative',
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#001C4C'
      }}
    >
      {/* Header with logo and event info */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 30,
        width: '100%',
        padding: '2.5rem'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            textAlign: 'left'
          }}>
            <p className={'text-[5vw]'} style={{
              fontWeight: 'bold',
              lineHeight: 1,
              color: 'white',
            }}>
              Farruko
            </p>
            <p className={'text-[3vw]'} style={{
              fontWeight: 500,
              lineHeight: 1,
              textTransform: 'uppercase',
              color: 'white',
            }}>
              13 Juillet
            </p>
          </div>
          <img
            src={"/feq.png"}
            alt={"FEQ"}
            className={'h-[6vh]'}
          />
        </div>
      </div>

      {/* Main image section - takes up most of the screen */}
      <div style={{
        position: 'relative',
        flex: 1,
        width: '100%'
      }}>
        <img src={"/july13.png"} alt={"Avril Lavigne"} style={{ objectFit: "cover", position: "absolute", width: "100%", height: "100%" }} />
        {/* Gradient overlay for better text readability */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50%',
          background: 'linear-gradient(to top, #001C4C, transparent)',
          zIndex: 10
        }} />
      </div>

      {/* Bottom section with pricing info */}
      <div style={{
        position: 'relative',
        zIndex: 20,
        width: '100%',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '2rem'
      }}>
        <div style={{
          textAlign: 'center',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <div style={{
              color: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "0rem",
              width: "fit-content",
            }}>
              <p className={'text-[5vw]'} style={{
                fontWeight: 500,
                color: 'white',
                textAlign: "left",
              }}>
                Tarif Évènement :
              </p>
              <p className={'text-[3vw]'} style={{
                fontWeight: 500,
                color: 'white',
                textAlign: "left",
              }}>
                Event price
              </p>
            </div>
            <h1 className={'text-[16vw]'} style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}>
                        <span style={{
                          lineHeight: 1,
                          fontWeight: 'bold',
                          color: 'white'
                        }}>25</span>
              <span className={'text-[7vw]'} style={{
                fontWeight: 'bold',
                lineHeight: 1,
                color: 'white',
              }}>
                            $
                        </span>
            </h1>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '0.5rem',
            justifyContent: "space-between"
          }}>
            <div style={{
              display: "flex",
              flexDirection: "column",
            }}>
              <p className={'text-[5vw]'} style={{
                fontWeight: 500,
                color: 'white',
                textAlign: "left",
              }}>
                Tarif Hôtel :
              </p>
              <p className={'text-[3vw]'} style={{
                fontWeight: 500,
                color: 'white',
                textAlign: "left",
              }}>
                Hotel guest
              </p>
            </div>
            <p className={'text-[7vw]'} style={{
              fontWeight: 'bold',
              color: 'white',
            }}>
              28.95$ / Nuité(s)
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function DeltaHotel() {
  const regularScreens = [RateScreen, TextScreen];
  //const eventScreens = [EventScreen, TextScreen];

  /*const [currentScreens, setCurrentScreens] = useState(regularScreens);

  useEffect(() => {
    const checkTimeAndSetScreens = () => {
      // Get current time in Quebec/Montreal timezone
      const now = moment().tz('America/Montreal');

      const eventStartHour = 15; // 3 PM
      const eventEndHour = 22;   // 10 PM

      const currentHour = now.hour(); // Use moment's hour() method

      console.log('Current Montreal time:', now.format('YYYY-MM-DD HH:mm:ss'));
      console.log('Current hour:', currentHour);

      if (currentHour >= eventStartHour && currentHour < eventEndHour) {
        setCurrentScreens(eventScreens);
        console.log('Showing event screens');
      } else {
        setCurrentScreens(regularScreens);
        console.log('Showing regular screens');
      }
    };

    checkTimeAndSetScreens();

    const interval = setInterval(checkTimeAndSetScreens, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);*/

  return (
    <>
      <AutoRefresh intervalms={900000} />
      <RotatingComponents screens={regularScreens} interval={5500} />
    </>
  );
}


export default DeltaHotel;
